var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import { debounce } from "lodash";
import * as React from "react";
import { Query } from "react-apollo";
import { Spinner } from "./Spinner";
import i18next from "i18next";
var debounceTimeInMs = 300;
var SelectUser = /** @class */ (function (_super) {
    __extends(SelectUser, _super);
    function SelectUser(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { debouncedSearchText: "" };
        _this.deboucedSearch = debounce(function (func) { return func(); }, debounceTimeInMs);
        return _this;
    }
    SelectUser.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement("div", { tabIndex: -1, onFocus: function () { return _this.setState({ searchFocused: true }); }, onBlur: function () { return _this.setState({ searchFocused: false }); } },
            React.createElement("input", { className: "form-control", type: "text", value: props.searchText, placeholder: props.placeholder, disabled: props.disabled, onChange: function (ev) { return props.onSearchTextChange(ev.currentTarget.value); } }),
            React.createElement("div", { style: { position: "relative" } },
                React.createElement("div", { className: "box mt-2 py-2", style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        maxHeight: 300,
                        display: this.state.searchFocused && props.searchText ? "block" : "none",
                        overflow: "auto",
                        border: "1px solid lightgray",
                    } }, this.renderSearch()))));
    };
    SelectUser.prototype.renderSearch = function () {
        var _this = this;
        var props = this.props;
        return (React.createElement(LookupUsersQuery, { query: lookupUserGql, skip: !this.state.debouncedSearchText, variables: {
                key: this.state.debouncedSearchText,
                organizationId: this.props.organizationId,
            }, fetchPolicy: "network-only", client: this.props.context.client }, function (result) {
            if (result.loading ||
                props.searchText !== _this.state.debouncedSearchText) {
                return (React.createElement("div", { className: "text-center" },
                    React.createElement(Spinner, null)));
            }
            if (result.error) {
                return React.createElement("div", { className: "alert alert-danger" }, i18next.t("cc.select.users.somethingWentWrong"));
            }
            if (!result.data) {
                return null;
            }
            if (result.data.usersByKey.length === 0) {
                return (React.createElement("div", { className: "px-2 text-center text-black-50" }, i18next.t("cc.select.users.noHits")));
            }
            return (React.createElement(React.Fragment, null, result.data.usersByKey.map(function (user) { return (React.createElement(UserOption, { key: user.id, user: user, onSelect: function () {
                    props.onSelected(user);
                    props.onSearchTextChange("");
                } })); })));
        }));
    };
    SelectUser.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.searchText !== this.props.searchText) {
            this.deboucedSearch(function () {
                return _this.setState({ debouncedSearchText: _this.props.searchText });
            });
        }
    };
    return SelectUser;
}(React.Component));
export { SelectUser };
var UserOption = function (props) { return (React.createElement("div", { className: "px-2", onClick: props.onSelect, style: { cursor: "pointer" } },
    props.user.name,
    props.user.emails.length > 0 ? (React.createElement(React.Fragment, null,
        "\u00A0",
        " ",
        React.createElement("small", { className: "text-black-50" }, props.user.emails[0].value),
        " ")) : null)); };
var lookupUserGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query SelectUsersLookup($key: String!, $organizationId: String!) {\n    usersByKey(key: $key, organizationId: $organizationId) {\n      id\n      name\n      nationalId\n      tfNumber\n      username\n      organization {\n        id\n        name\n        country\n      }\n      emails {\n        value\n      }\n    }\n  }\n"], ["\n  query SelectUsersLookup($key: String!, $organizationId: String!) {\n    usersByKey(key: $key, organizationId: $organizationId) {\n      id\n      name\n      nationalId\n      tfNumber\n      username\n      organization {\n        id\n        name\n        country\n      }\n      emails {\n        value\n      }\n    }\n  }\n"])));
var LookupUsersQuery = Query;
var templateObject_1;
//# sourceMappingURL=SelectUsers.js.map